function updateEndDatePicker(value) {
  if (!value) return;

  const startDatePicker = document.getElementById("start_date_picker");
  const endDatePicker = document.getElementById("end_date_picker");

  if (!startDatePicker || !endDatePicker) return;

  const chooseDate = new Date();
  const nowDate = new Date();

  chooseDate.setDate(chooseDate.getUTCDate() + parseInt(value, 10));
  nowDate.setDate(nowDate.getUTCDate());

  const startDate =
    nowDate.getFullYear() +
    "-" +
    `0${nowDate.getMonth() + 1}`.slice(-2) +
    "-" +
    `0${nowDate.getDate()}`.slice(-2);

  const futureDate =
    chooseDate.getFullYear() +
    "-" +
    `0${chooseDate.getMonth() + 1}`.slice(-2) +
    "-" +
    `0${chooseDate.getDate()}`.slice(-2);

  startDatePicker.value = startDate;
  endDatePicker.value = futureDate;
}

function initializeShowcaseTimer() {
  const timerSwitch = document.getElementById("timer-switch");
  const timerDuration = document.getElementById("timer-duration");
  const startDatePicker = document.getElementById("start_date_picker");
  const endDatePicker = document.getElementById("end_date_picker");
  const durationSelectors = document.querySelectorAll(
    ".timer-duration-selector",
  );

  if (
    !timerSwitch ||
    !timerDuration ||
    !startDatePicker ||
    !endDatePicker ||
    durationSelectors.length === 0
  ) {
    return;
  }

  const selectedDuration = () =>
    document.querySelector(".timer-duration-selector:checked")?.value;

  const syncTimerState = () => {
    if (timerSwitch.checked) {
      updateEndDatePicker(selectedDuration());
      timerDuration.classList.remove("d-none");
      endDatePicker.setAttribute("readonly", true);
      return;
    }

    timerDuration.classList.add("d-none");
    endDatePicker.removeAttribute("readonly");
  };

  startDatePicker.addEventListener("change", () => {
    if (timerSwitch.checked) {
      updateEndDatePicker(selectedDuration());
    }
  });

  durationSelectors.forEach((selector) => {
    selector.addEventListener("change", () => {
      updateEndDatePicker(selector.value);
    });
  });

  timerSwitch.addEventListener("change", syncTimerState);

  syncTimerState();
}

document.addEventListener("turbo:load", initializeShowcaseTimer);
